import { c as _c } from "react/compiler-runtime";
import { useMutation, useQuery } from '@apollo/client/react';
import { Button, Icon, Box } from '@chakra-ui/react';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { gql } from '@src/lib/gql';
import { parseAsString, useQueryState } from 'nuqs';
import React from 'react';
import { MdOutlineThumbUp, MdThumbUp } from 'react-icons/md';
type LikeButtonProps = {
  likeableType: string;
  likeableId: string;
  size?: string;
  color?: string;
};
export const LikeButton = props => {
  const $ = _c(24);
  const {
    currentUser
  } = useCurrentUser();
  const [, setPrompt] = useQueryState("prompt", parseAsString);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = LikeButton.queries.scoLikeable();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.likeableId || $[2] !== props.likeableType) {
    t1 = {
      variables: {
        likeableType: props.likeableType,
        likeableId: props.likeableId
      },
      ssr: false
    };
    $[1] = props.likeableId;
    $[2] = props.likeableType;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const query = useQuery(t0, t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = LikeButton.mutations.toggleLike();
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const [toggleLike] = useMutation(t2);
  const userHasLiked = query.data?.scoLikeable?.hasUserLiked || false;
  const likesCount = query.data?.scoLikeable?.likesCount;
  const t3 = userHasLiked ? "actionActive" : props.color || "actionPrimary";
  const t4 = `${props.size || "sm"}`;
  const t5 = `${userHasLiked ? "actionActive" : "white"}`;
  let t6;
  if ($[5] !== t5) {
    t6 = {
      color: t5,
      textDecoration: "none",
      transform: "scale(1.2)"
    };
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== currentUser?.isRegistered || $[8] !== props.likeableId || $[9] !== props.likeableType || $[10] !== setPrompt || $[11] !== toggleLike) {
    t7 = e => {
      e.stopPropagation();
      if (currentUser?.isRegistered) {
        toggleLike({
          variables: {
            input: {
              likeableType: props.likeableType,
              likeableId: props.likeableId
            }
          }
        });
      } else {
        setPrompt("register");
      }
    };
    $[7] = currentUser?.isRegistered;
    $[8] = props.likeableId;
    $[9] = props.likeableType;
    $[10] = setPrompt;
    $[11] = toggleLike;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== userHasLiked) {
    t8 = userHasLiked ? <Icon asChild={true}><MdThumbUp /></Icon> : <Icon asChild={true}><MdOutlineThumbUp /></Icon>;
    $[13] = userHasLiked;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== likesCount) {
    t9 = likesCount > 0 && <Box display="inline-block" paddingLeft="0.67em">{likesCount}</Box>;
    $[15] = likesCount;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t3 || $[18] !== t4 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t10 = <Button color={t3} cursor="pointer" minWidth={0} padding={0} size={t4} variant="ghost" _hover={t6} onClick={t7}>{t8}{t9}</Button>;
    $[17] = t3;
    $[18] = t4;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};
LikeButton.queries = {
  scoLikeable: () => gql`
    query($likeableType: String!, $likeableId: String!) {
      scoLikeable(likeableType: $likeableType, likeableId: $likeableId) {
        ${LikeButton.fragments.ScoLikeable()}
      }
    }
  `
};
LikeButton.fragments = {
  ScoLikeable: () => gql`
    fragment _ on ScoLikeable {
      id
      canUserLike
      hasUserLiked
      likesCount
    }
  `
};
LikeButton.mutations = {
  toggleLike: () => gql`
    mutation($input: ToggleLikeInput!) {
      toggleLike(input: $input) {
        likeable {
          ${LikeButton.fragments.ScoLikeable()}
        }
      }

    }
  `
};